
/** DO NOT EDIT THIS FILE! */
import { Version } from '@angular/core';
import { Bundle } from './models';

export const VERSION = new Version('1.47.41');

export const BUNDLE: Bundle = {
  date: 1783995492334,
  commitSha: 'unknown',
  version: VERSION,
};
